import React from 'react'
import styels from './Projects.module.css'
import bg2 from '../../asssists/22.jpg'
import Card from '../Card/Card'
export default function Projects() {
  return (
    <>
    <section className={styels.project}>
   <img className={styels.projectBg} src={bg2} alt="" />
  <div className={styels.projectContent}>
    <Card/>
  </div>
   </section>
    </>
  )
}
